import { Component, HostBinding, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'codemiro-page-layout',
  template: '<ng-content></ng-content>',
  host: {
    class: 'codemiro-page-layout'
  },
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./page-layout.component.scss']
})
export class PageLayoutComponent {

  @Input() mode: 'card' | 'simple' = 'simple';

  constructor() { }

  @HostBinding('class.codemiro-page-layout-card')
  get isCard() {
    return this.mode === 'card';
  }

  @HostBinding('class.codemiro-page-layout-simple')
  get isSimple() {
    return this.mode === 'simple';
  }

}
